const normalisedLobIcons = {
    PA: {
        image: 'personal-auto',
     //   font: 'mi-directions_car'
        font: 'fa_car'
    },
    HO: {
        image: 'home-owners',
      //  font: 'mi-home'
        font: 'fa-home'
    },
    GL: {
        image: 'general-liability',
        font: 'fa-tractor'
        //font: 'mi-healing'
    },
    BO: {
        image: 'business-owners',
        // font: 'mi-store'
        font: 'fa-building'
    },
    IM: {
        image: 'inland-marine',
        font: 'mi-directions_boat'
      //  font: 'fa-ship'
    },
    CP: {
        image: 'commercial-property',
        font: 'mi-unarchive'
    },
    CA: {
        image: 'commercial-auto',
        font: 'mi-local_shipping'
    },
    WC: {
        image: 'workers-comp',
        font: 'mi-work'
    },
    CPKG: {
        image: 'commercial-package',
        font: 'mi-unarchive'
    },
    TRVL: {
        image: 'travel',
        font: 'mi-plane'
    },
    PUL: {
        image: 'no-icon',
        font: 'fa-umbrella'
    },
    BP7: {
        image: 'farm',
        font: 'fa-tractor'
       //  font: 'fa-leaf'
    },
    GA: {
        image: 'garage',
        font: 'fa-warehouse'
    },
    default: {
        image: 'no-icon', // Using an existing empty image as default to avoid 404s
        font: 'mi-receipt'
    }
};

const lobKeys = {
    PersonalAuto: 'PA',
    PersonalAutoLine: 'PA',
    auto_per: 'PA',
    Homeowners: 'HO',
    homeowners: 'HO',
    HomeOwners: 'HO',
    HomeownersLine_HOE: 'HO',
    HomeownersLine: 'HO',
    HOPLine: 'HO',
    HOLine: 'HO',
    HOPHomeowners: 'HO',
    GeneralLiability: 'GL',
    GeneralLiabilityLine: 'GL',
    GLLine: 'GL',
    Businessowners: 'BO',
    BusinessOwners: 'BO',
    BusinessOwnersLine: 'BO',
    BOPLine: 'BO',
    InlandMarine: 'IM',
    InlandMarineLine: 'IM',
    IMLine: 'IM',
    CommercialProperty: 'CP',
    CommercialPropertyLine: 'CP',
    CPLine: 'CP',
    CommercialAuto: 'PA', 
    BusinessAuto: 'PA',
    BusinessAutoLine: 'PA',
    WorkersComp: 'WC',
    WorkersCompLine: 'WC',
    WC7WorkersComp: 'WC',
    CommercialPackage: 'CPKG',
    CommercialPackageLine: 'CPKG',
    travel_perLine: 'TRVL',
    PersonalUmbrellaLine: 'PUL',
    PersonalUmbrella: 'PUL',
    BP7Line: 'BP7',
    BP7BusinessOwners: 'BP7',
    BusinessFleet: 'CA',
    GA7Garage: 'GA'
};

const getNormalisedObject = (lobCode) => {
    const normalisedKey = lobKeys[lobCode] || 'default';
    return normalisedLobIcons[normalisedKey];
};

export function getFontIcon(lobCode){
    return getNormalisedObject(lobCode).font;
}
